<div class="topbar-group">
  @if (icon$ | async; as _icon) {
    <div style="fill: #d81020" class="me-5" [innerHTML]="_icon | SafeHTML"></div>
  }
  <!--end::Page Icon-->
  <!--begin::Page Title-->
  <div class="topbar-tenant">
    @if ((title$ | async); as _title) {
      @if ((user$ | async); as _user) {
        <h1 class="text-dark fw-bold my-1">
          {{ _title }}
        </h1>
        <div style="display: flex; align-items: center;">
          <mat-icon class="person-pin-icon tenant-name-badge-icon">person_pin</mat-icon>
          <span class="badge badge-warning fw-bold px-2 py-1 tenant-name-badge">
            {{ _user.tenant.name ?? _user.tenant.tenancyName }}
          </span>
        </div>
      }
    }
  </div>
  <div class="ps-10 mt-2">
    @if (requireExportIconsPage) {
      <div class="sc-export-btn-viewgroup d-flex align-items-center">
        <div class="text-end">
          <label for="exportCSVBtn">&nbsp;</label>
          <div class="input-group export-btns">
            <button type="button" [disabled]="(isExportingCSV$ | async) || (isExportingIncidentReportCSV$ | async) || (isExportingMonthlyDashboardCSV$ | async) || (isExportingAssetDashboardCSV$ | async)"
              class="btn btn-md btn-icon btn-icon-md btn-circle mx-1 btn-export-csv" id="exportCSVBtn"
              title="Export to CSV" (click)="triggerExport(1, requireExportIconsPage)" matTooltip="Export to CSV">
              @if (!((isExportingCSV$ | async) || (isExportingIncidentReportCSV$ | async) || (isExportingMonthlyDashboardCSV$ | async) || (isExportingAssetDashboardCSV$ | async))) {
                <i class="fa fa-file-o" style="margin-right: 0px;"></i>
              } @else {
                <span class="spinner spinner-light spinner-track spinner-lg spinner-center"></span>
              }
            </button>
          </div>
        </div>
        <div class="text-end">
          <label for="exportXLSBtn">&nbsp;</label>
          <div class="input-group export-btns">
            <button type="button" [disabled]="(isExportingExcel$ | async) || (isExportingIncidentReportExcel$ | async) || (isExportingMonthlyDashboardExcel$ | async) || (isExportingAssetDashboardExcel$ | async)"
              class="btn btn-md btn-icon btn-icon-md btn-circle mx-1 btn-export-xls" id="exportXLSBtn"
              title="Export to Excel" (click)="triggerExport(2, requireExportIconsPage)" matTooltip="Export to Excel">
              @if (!((isExportingExcel$ | async) || (isExportingIncidentReportExcel$ | async) || (isExportingMonthlyDashboardExcel$ | async)  || (isExportingAssetDashboardExcel$ | async))) {
                <i class="fa fa-file-excel-o" style="margin-right: 0px;"></i>
              } @else {
                <span class="spinner spinner-light spinner-track spinner-lg spinner-center"></span>
              }
            </button>
          </div>
        </div>
        @if (requireExportPdfIconsPage) {
          <div class="text-end">
            <label for="exportPDFBtn">&nbsp;</label>
            <div class="input-group export-btns">
              <button type="button" [disabled]="(isExportingPDF$ | async) || (isExportingIncidentReportPDF$ | async) || (isExportingMonthlyDashboardPDF$ | async)"
                class="btn btn-md btn-icon btn-icon-md btn-circle mx-1 btn-export-pdf" id="exportPDFBtn"
                title="Export to PDF" (click)="triggerExport(3, requireExportIconsPage)" matTooltip="Export to PDF">
                @if (!((isExportingPDF$ | async) || (isExportingIncidentReportPDF$ | async) || (isExportingMonthlyDashboardPDF$ | async))) {
                  <i class="fa fa-file-pdf-o" style="margin-right: 0px;"></i>
                } @else {
                  <span class="spinner spinner-light spinner-track spinner-lg spinner-center"></span>
                }
              </button>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>

<div class="topbar-group">

  @if (hasDashboardPermission) {
    <div class="pt-1">
      <sc-tenant-statistics class=""></sc-tenant-statistics>
    </div>
  }

  @if (user$ | async; as _user) {
    <!--begin::User-->
    <div class="dropdown sc-account-tour" #dropDown ngbDropdown placement="bottom-right">
      <div ngbDropdownToggle class="topbar-item nav-link" data-offset="0px,0px" tabindex="0" role="button" (click)="getLinkedTenantsList()">
        <span class="text-dark-50 fw-bolder font-size-base d-none d-md-inline text-break truncate-text">
          @if (_user.isImpersonated) {
            <span>
              <mat-icon color="primary">reply</mat-icon>
            </span>
          }
          {{ _user.userName }}
        </span>
      </div>
      <div ngbDropdownMenu class="dropdown-menu p-0 m-0 dropdown-menu-lg dropdown-menu-anim-up">
        <form>
          <div class="card card-custom gutter-b shadow-light">
            <!--begin::Header-->
            <div class="p-6 bgi-size-cover bgi-no-repeat rounded-top bg-dark">
              <p class="text-white">{{_user.tenant.name ?? _user.tenant.tenancyName}}</p>
              <h4 class="text-white">{{ _user.name }} {{ _user.surname }}</h4>
              <p class="text-white m-0 flex-grow-1 text-break">{{ _user.emailAddress }}</p>
            </div>
            <!--end::Header-->
            @if (_user.isImpersonated) {
              <div class="card-body p-5">
                <div class="text-start">
                  <a class="d-flex flex-row align-items-center btn" (click)="unimpersonate()">
                    @if (!(loggingOut$ | async)) {
                      <mat-icon class="pe-3" color="primary">reply</mat-icon>
                    }
                    @if ((loggingOut$ | async)) {
                      <span class="spinner spinner-primary spinner-track spinner-sm pe-7"></span>
                    }
                    Back to my account
                  </a>
                </div>
              </div>
            }
            <div class="overflow-auto switch-account">
              @if (linkedUser?.length > 1) {
                <div class="search-bar">
                  <div class="position-sticky">
                    <form [formGroup]="linkedTenantForm">
                      <div class="position-relative">
                        <input matInput type="text" class="form-control search-input" formControlName="userId" placeholder="Search Tenant">
                        <mat-icon class="search-icon">search</mat-icon>
                      </div>
                    </form>
                  </div>
                </div>
              }
              <div class="options-container">
                @if (!isFilterApplied) {
                  <ng-container class="scrollable-select">
                    @for (user of linkedUser; track user) {
                      @if (user.userId != _user.id) {
                        <button type="button" class="btn btn-light d-flex align-items-center w-100"  (click)="switchTenant(user.userId, user.tenantId)">
                          <mat-icon class="mx-1 person-pin-icon">person_pin</mat-icon>
                          <span class="text-start">{{ user.tenantName ?? user.tenancyName }}</span>
                          @if (switchTenantLoadingMap[user.userId]) {
                            <span class="spinner spinner-primary spinner-track spinner-sm ms-auto me-5"></span>
                          }
                        </button>
                      }
                    }
                  </ng-container>
                } @else {
                  @for (user of filtered$ | async; track user) {
                    @if (user.userId != _user.id) {
                      <button type="button" class="btn btn-light d-flex align-items-center w-100"  (click)="switchTenant(user.userId, user.tenantId)">
                        <mat-icon class="mx-1 person-pin-icon">person_pin</mat-icon>
                        <span class="text-start">{{ user.tenantName ?? user.tenancyName }}</span>
                        @if (switchTenantLoadingMap[user.userId]) {
                          <span class="spinner spinner-primary spinner-track spinner-sm ms-auto me-5"></span>
                        }
                      </button>
                    }
                  }
                }
                @if ((filtered$ | async)?.length === 0 && isFilterApplied) {
                  <div class="no-tenants-found">
                    No tenants found.
                  </div>
                }
              </div>
            </div>
            <!--begin::Logout-->
            <div class="card-footer p-5">
              <div class="text-end">
                @if (!isLinkedUsers) {
                  <button type="button" class="btn btn-pill btn-primary text-dark px-10 text-weight-bold"
                    (click)="changePassword(dropDown)">
                    Change Password
                  </button>
                }
                <button type="button" class="btn btn-pill btn-primary text-dark px-10 ms-2 text-weight-bold"
                  (click)="logout()">
                  Logout
                </button>
              </div>
            </div>
            <!--end::Logout-->
          </div>
        </form>
      </div>
    </div>
    <!--end::User-->
  }

</div>

